import * as React from 'react';

type Props = {
    classes?: string;
    type: 'button' | 'submit' | 'reset' | undefined;
    link?: string;
    onClick?: (event: any) => void;
    disabled?: boolean;
    children?: React.ReactNode;
    ariaLabel?: string;
};

export const ButtonWithChildren = ({ classes, type = 'button', link, onClick, disabled, children, ariaLabel }: Props) => {
    return (
        <>
            {!link && (
                <button
                    type={type}
                    className={classes}
                    onClick={onClick}
                    disabled={disabled}
                    aria-label={ariaLabel}
                >
                    {children}
                </button>
            )}

            {link && (
                // @ts-ignore
                <a
                    href={link}
                    className='w-full lg:w-auto'
                >
                    <button className={`${type} button btn-link`}>{children}</button>
                </a>
            )}
        </>
    );
};

export default ButtonWithChildren;
